import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import referenceOJKSliceService from "services/Setup/Master/referenceOJKSliceService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  interestTypeList: [],
  rojkJabatanList: [],
};

export const referenceOJKList = createAsyncThunk(
  "referenceOJKSlice/referenceOJKList",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ response:referenceOJKList");
    try {
      const response = await referenceOJKSliceService.referenceOJKList();
      console.log("🚀 ~ referenceOJKSliceServiceresponse:", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:referenceOJKList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const referenceOJKSlice = createSlice({
  name: "referenceOJKSlice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //referenceOJKList list
      .addCase(referenceOJKList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(referenceOJKList.fulfilled, (state, action) => {
        state.loading = false;
        state.rojkJabatanList = action.payload.data;
      })
      .addCase(referenceOJKList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  referenceOJKSlice.actions;

export default referenceOJKSlice.reducer;
